import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("scrollable-container", () => {
    it("should render a component", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-scrollable-container></ux-scrollable-container>`
        );
        const scrollbarContainerElement = await page.find(
            "ux-scrollable-container"
        );
        expect(scrollbarContainerElement).toHaveClass("hydrated");
    });

    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<div>
                <ux-scrollable-container scrollbar-placement="top-bottom">
                    <div
                        style="height: 300px; width: 2000px; background: #c6d4dd; color: #fff; display: flex; justify-content: center; align-items: center; font-size: 35px; letter-spacing: 8px"
                    >
                        Scrollable Element
                    </div>
                </ux-scrollable-container>
            </div>`
        );
        const el = await page.find("ux-scrollable-container");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should render valid html", async () => {
        await testValidHtml(`<div>
                <ux-scrollable-container scrollbar-placement="top-bottom">
                    <div
                        style="height: 300px; width: 2000px; background: #c6d4dd; color: #fff; display: flex; justify-content: center; align-items: center; font-size: 35px; letter-spacing: 8px"
                    >
                        Scrollable Element
                    </div>
                </ux-scrollable-container>
            </div>`);
    });
});
